var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.8496 0H15.8496C5.84961 0 0.849609 5 0.849609 15V47.5C0.849609 48.875 1.97461 50 3.34961 50H35.8496C45.8496 50 50.8496 45 50.8496 35V15C50.8496 5 45.8496 0 35.8496 0ZM30.8496 33.125H13.3496C12.3246 33.125 11.4746 32.275 11.4746 31.25C11.4746 30.225 12.3246 29.375 13.3496 29.375H30.8496C31.8746 29.375 32.7246 30.225 32.7246 31.25C32.7246 32.275 31.8746 33.125 30.8496 33.125ZM38.3496 20.625H13.3496C12.3246 20.625 11.4746 19.775 11.4746 18.75C11.4746 17.725 12.3246 16.875 13.3496 16.875H38.3496C39.3746 16.875 40.2246 17.725 40.2246 18.75C40.2246 19.775 39.3746 20.625 38.3496 20.625Z",
    fill: "#6C84F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.2c084d969689ab78830733709191e608.svg";
export { ForwardRef as ReactComponent };